import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const options = [
  {
    id: "daily",
    label: "Daily",
    copy: "Quick Auburn stop.",
  },
  {
    id: "weekly",
    label: "Weekly",
    copy: "Build a full Sierra Foothills itinerary.",
  },
  {
    id: "monthly",
    label: "Monthly",
    copy: "Make Auburn your extended base camp.",
  },
];

export function StayLonger() {
  return (
    <section
      id="stay-longer"
      aria-labelledby="stay-longer-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>There&apos;s More to See</Eyebrow>
        </Reveal>
        <h2 id="stay-longer-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>One Night Might Not</MaskReveal>
          <MaskReveal delay={0.08}>Be Enough</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground">
            With outdoor adventures, Gold Country, local food and drink, historic towns and Sierra
            day trips surrounding Auburn, staying a little longer gives you more time to experience
            Northern California your way.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-4 md:grid-cols-3">
          {options.map((option, i) => (
            <li key={option.id}>
              <Reveal delay={i * 0.07} className="h-full">
                <article className="flex h-full flex-col border border-border bg-card p-8 md:p-10">
                  <h3 className="eyebrow text-primary">{option.label}</h3>
                  <p className="mt-6 flex-1 text-base leading-relaxed text-muted-foreground">
                    {option.copy}
                  </p>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>

        <Reveal delay={0.12}>
          <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="solid" href="/rates/" className="w-full sm:w-auto">
              View Rates
            </ResortLink>
            <ResortLink variant="outline" href="/accommodations/" className="w-full sm:w-auto">
              Explore Accommodations
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
